import { ImageResponsive } from '@/components/commons/images/ImageResponsive.component'
import { Text } from '@/components/commons/typography/Text'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'
import { cssClass } from '@/shared/utils'
import { colorsV2 } from '@/styles/v2/vars/vars.colors'
import { Button } from '@mantine/core'
import { DealSyncCard } from 'containers/deal-sync/DealSyncCard'
import { useHighlights } from 'containers/highlights/hooks/useHighlights'
import { useProjects } from 'containers/projects/hooks/useProjects'
import { RecommendationsSection } from 'containers/recommendations/components/recommendations-section/RecommendationSection'
import { useUser } from 'containers/user/hooks/useUser'
import { BrowserContext } from 'context'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useContext, useMemo } from 'react'
import { SuperchargeCard } from './SuperchargeCard'

export const RightColumnSection = () => {
  const { isAuth } = useUser()
  const router = useRouter()
  const { isMobile } = useContext(BrowserContext)
  const { highlights } = useHighlights()
  const { data: projects } = useProjects()

  const hasHighlightsOrProjects = useMemo(() => {
    const hCount = highlights?.length || 0
    const pCount = projects?.length || 0

    return hCount > 0 || pCount > 0
  }, [highlights, projects])

  const activePath = useMemo(() => {
    const path = router.pathname

    switch (path) {
      case '/[username]':
        return '[username]'

      case '/[username]/views':
        return 'views'

      case '/[username]/network':
        return 'network'

      default:
        return path
    }
  }, [router.pathname])

  if (!isAuth) return <RecommendationsSection />

  return (
    <div className="flex flex-column gap-30 mt-0">
      <section className="flex full-w flex-column gap-30 px-20 px-0--tablet">
        {isMobile && (hasHighlightsOrProjects || activePath === 'views') && (
          <span
            className={cssClass([
              'border-t-secondary border-t-1 pt-20 border-t-solid',
              activePath === 'views' ? 'mt-15' : 'mt-30',
            ])}
          ></span>
        )}
        <div className="bg-white-primary rounded-18 p-24 flex flex-column gap-14 items-center justify-center">
          <Text
            as="h2"
            sizeClass="text-16"
            colorClass="text-black"
            weightClass="font-bold"
            className="text-center"
          >
            Introducing the Super List
          </Text>

          <Text
            variation="small"
            colorClass="text-tertirary"
            className="text-center"
          >
            Free database of 500+ verified brand contacts & 10,000+ creator
            profiles - no more cold outreach guesswork
          </Text>

          <div className="full-w">
            <ImageResponsive
              src={IMAGE_PATHS_V2.profileV2 + 'super-list.png'}
              alt="Creatorland Insider"
              sizes="335px"
              className="full-w"
            />
          </div>
          <div className="flex gap-12 full-w">
            <Link
              href="https://bit.ly/4m77oaT"
              passHref
              target="_blank"
              className="flex-1"
            >
              <Button
                variant="full"
                bg={colorsV2.accent.light.primary}
                fullWidth
                tt="uppercase"
                c="black"
                radius={10}
              >
                ACCESS THE SUPER LIST FREE
              </Button>
            </Link>
          </div>
        </div>

        <div className="hidden block--tablet">
          <DealSyncCard />
        </div>

        <SuperchargeCard />
      </section>

      <RecommendationsSection />
    </div>
  )
}
